<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { passwordStrength } from "@/helpers/validation";

const { t } = useI18n();
const props = defineProps<{
    password: string;
    formSender: boolean;
}>();

const validationResult = computed(() => passwordStrength(props.password));

const checkValidation = (rule: string) => {
    const result = validationResult.value;
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    return result === true || (Array.isArray(result) && !result.some((r: any) => r.validation === rule));
};

const has8Chars = computed(() => checkValidation("min"));
const has1Maj = computed(() => checkValidation("uppercase"));
const has1Number = computed(() => checkValidation("digits"));
const has1Symbol = computed(() => checkValidation("symbols"));
</script>

<template>
    <div class="PasswordStrength">
        <p>
            <i :class="{ 'ti ti-check': has8Chars, 'ti ti-point-filled': !has8Chars && !formSender, 'ti ti-x': !has8Chars && formSender }"></i>
            <span :class="{ colorField: !has8Chars && formSender }">{{ t("form.passwordStrength.min8Chars") }}</span>
        </p>
        <p>
            <i :class="{ 'ti ti-check': has1Maj, 'ti ti-point-filled': !has1Maj && !formSender, 'ti ti-x': !has1Maj && formSender }"></i>
            <span :class="{ colorField: !has1Maj && formSender }">{{ t("form.passwordStrength.min1Maj") }}</span>
        </p>
        <p>
            <i :class="{ 'ti ti-check': has1Number, 'ti ti-point-filled': !has1Number && !formSender, 'ti ti-x': !has1Number && formSender }"></i>
            <span :class="{ colorField: !has1Number && formSender }">{{ t("form.passwordStrength.min1Number") }}</span>
        </p>
        <p>
            <i :class="{ 'ti ti-check': has1Symbol, 'ti ti-point-filled': !has1Symbol && !formSender, 'ti ti-x': !has1Symbol && formSender }"></i>
            <span :class="{ colorField: !has1Symbol && formSender }">{{ t("form.passwordStrength.min1Symbol") }}</span>
        </p>
    </div>
</template>

<style lang="scss">
.PasswordStrength {
    //margin-top: calc($padding / 2);
    //margin-bottom: calc($padding / 2);

    p {
        transition: 0.2s linear;
        color: $neutral-500;
        display: flex;
        margin-bottom: 4px;
        font-size: 14px;
        gap: 4px;
        line-height: 20px;
        align-items: center;

        .ti-check {
            color: $green-base;
            font-size: 12px;
        }
        .ti-point-filled {
            color: $icon-sub-500;
            font-size: 12px;
        }
        .ti-x {
            color: $red-base;
            font-size: 12px;
        }
        .colorField {
            color: $red-base;
        }
    }
}
</style>
